// extracted by mini-css-extract-plugin
module.exports = {"topTen":"styles_topTen__1TNF0"};